(() => {
  const root = document.querySelector('[data-zv-localization]');
  if (!root) return;
  const form = root.querySelector('form');
  const country = form.elements.country_code;
  const language = form.elements.language_code;
  const preferenceKey = 'zayvi_localization_choice_v1';
  const attemptKey = 'zayvi_localization_attempt_v1';
  let automatic = false;
  const read = (storage, key) => { try { return storage.getItem(key); } catch { return null; } };
  const write = (storage, key, value) => { try { storage.setItem(key, value); } catch {} };
  document.addEventListener('submit', (event) => {
    if (event.target instanceof HTMLFormElement && event.target.querySelector('[name="form_type"][value="localization"]') && !automatic) {
      write(localStorage, preferenceKey, 'manual');
    }
  }, true);
  if (root.dataset.auto !== 'true' || read(sessionStorage, attemptKey)) return;
  if (read(localStorage, preferenceKey)) return;
  const url = new URL(window.location.href);
  if (url.pathname !== '/' || url.search || /bot|crawler|spider|preview/i.test(navigator.userAgent)) return;
  write(sessionStorage, attemptKey, '1');
  const allowed = (select, value) => [...select.options].some(option => option.value === value);
  const detect = async () => {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 3500);
    let suggestedCountry = root.dataset.country;
    let suggestedLanguage = root.dataset.language;
    try {
      const endpoint = new URL('browsing_context_suggestions.json', window.location.origin + '/');
      endpoint.searchParams.set('country[enabled]', 'true');
      endpoint.searchParams.set('language[enabled]', 'true');
      const response = await fetch(endpoint, { signal: controller.signal, credentials: 'same-origin' });
      if (response.ok) {
        const data = await response.json();
        const suggestion = data.suggestions?.[0]?.parts;
        const detectedCountry = suggestion?.country?.handle || data.detected_values?.country?.handle;
        const detectedLanguage = suggestion?.language?.handle || data.detected_values?.language?.handle;
        if (allowed(country, detectedCountry)) suggestedCountry = detectedCountry;
        if (allowed(language, detectedLanguage)) suggestedLanguage = detectedLanguage;
      }
      const browserLanguages = navigator.languages || [navigator.language];
      for (const locale of browserLanguages) {
        const short = locale.toLowerCase().split('-')[0];
        if (allowed(language, short)) { suggestedLanguage = short; break; }
      }
      if (suggestedCountry === root.dataset.country && suggestedLanguage === root.dataset.language) return;
      country.value = suggestedCountry;
      language.value = suggestedLanguage;
      automatic = true;
      form.requestSubmit();
    } catch {} finally { clearTimeout(timeout); }
  };
  if ('requestIdleCallback' in window) window.requestIdleCallback(detect, { timeout: 1500 });
  else window.setTimeout(detect, 600);
})();
